import { RootState } from '@/Redux/RootReducer';
import { createSelector } from '@reduxjs/toolkit';

const generatorProductsState = (state: RootState) => state.warehouseLogisticsPage.generationTemplates;

const productStatuses = createSelector(generatorProductsState, (state) => state.productStatuses);

const selectedCountry = createSelector(generatorProductsState, (state) => state.selectedCountry);

const selectedLogistic = createSelector(generatorProductsState, (state) => state.selectedLogistic);

const isCreatingNewTemplate = createSelector(generatorProductsState, (state) => state.isCreatingNewTemplate);

const needProductDuplicatedModal = createSelector(generatorProductsState, (state) => state.needProductDuplicatedModal);

const duplicatedProducts = createSelector(generatorProductsState, (state) => state.duplicatedProducts);

const templates = createSelector([generatorProductsState, selectedLogistic], (state, logistic) => {
  return state.templates.find((item) => item.logisticId == logistic)?.templates ?? [];
});

export const generatorProductSelectors = {
  productStatuses,
  selectedCountry,
  selectedLogistic,
  templates,
  isCreatingNewTemplate,
  needProductDuplicatedModal,
  duplicatedProducts,
};
